'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etime$002e$002dDate$002dTime$002dException from "./java.time.-Date-Time-Exception.js";
var $p;
/** @constructor */
function $c_Ljava_time_temporal_ValueRange(minSmallest_$_lo, minSmallest_$_hi, minLargest_$_lo, minLargest_$_hi, maxSmallest_$_lo, maxSmallest_$_hi, maxLargest_$_lo, maxLargest_$_hi) {
  this.gq = 0;
  this.gr = 0;
  this.jf = 0;
  this.jg = 0;
  this.jd = 0;
  this.je = 0;
  this.fN = 0;
  this.fO = 0;
  this.gq = minSmallest_$_lo;
  this.gr = minSmallest_$_hi;
  this.jf = minLargest_$_lo;
  this.jg = minLargest_$_hi;
  this.jd = maxSmallest_$_lo;
  this.je = maxSmallest_$_hi;
  this.fN = maxLargest_$_lo;
  this.fO = maxLargest_$_hi;
}
export { $c_Ljava_time_temporal_ValueRange as $c_Ljava_time_temporal_ValueRange };
$p = $c_Ljava_time_temporal_ValueRange.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_temporal_ValueRange;
/** @constructor */
function $h_Ljava_time_temporal_ValueRange() {
}
export { $h_Ljava_time_temporal_ValueRange as $h_Ljava_time_temporal_ValueRange };
$h_Ljava_time_temporal_ValueRange.prototype = $p;
$p.Vo = (function() {
  var x_$_lo = this.gq;
  var x_$_hi = this.gr;
  var x$1_$_lo = this.jf;
  var x$1_$_hi = this.jg;
  if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
    var x$2_$_lo = this.jd;
    var x$2_$_hi = this.je;
    var x$3_$_lo = this.fN;
    var x$3_$_hi = this.fO;
    return (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
  } else {
    return false;
  }
});
$p.Vp = (function() {
  var x_$_lo = this.gq;
  var x_$_hi = this.gr;
  if (((x_$_hi === (-1)) ? ((x_$_lo >>> 0) >= 2147483648) : (x_$_hi > (-1)))) {
    var x$1_$_lo = this.fN;
    var x$1_$_hi = this.fO;
    return ((x$1_$_hi === 0) ? ((x$1_$_lo >>> 0) <= 2147483647) : (x$1_$_hi < 0));
  } else {
    return false;
  }
});
$p.Pl = (function(value_$_lo, value_$_hi) {
  var x_$_lo = this.gq;
  var x_$_hi = this.gr;
  if (((value_$_hi === x_$_hi) ? ((value_$_lo >>> 0) >= (x_$_lo >>> 0)) : (value_$_hi > x_$_hi))) {
    var x$1_$_lo = this.fN;
    var x$1_$_hi = this.fO;
    return ((value_$_hi === x$1_$_hi) ? ((value_$_lo >>> 0) <= (x$1_$_lo >>> 0)) : (value_$_hi < x$1_$_hi));
  } else {
    return false;
  }
});
$p.Vy = (function(value_$_lo, value_$_hi) {
  return (this.Vp() && this.Pl(value_$_lo, value_$_hi));
});
$p.ak = (function(value_$_lo, value_$_hi, field) {
  if ((!this.Pl(value_$_lo, value_$_hi))) {
    if ((field !== null)) {
      throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((((("Invalid value for " + field) + " (valid values ") + this) + "): ") + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(value_$_lo, value_$_hi)));
    } else {
      throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((("Invalid value (valid values " + this) + "): ") + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(value_$_lo, value_$_hi)));
    }
  } else {
    return $j_java$002elang$002e$002dObject.$bL(value_$_lo, value_$_hi);
  }
});
$p.b0 = (function(value_$_lo, value_$_hi, field) {
  if ((!this.Vy(value_$_lo, value_$_hi))) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((("Invalid int value for " + field) + ": ") + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(value_$_lo, value_$_hi)));
  } else {
    return value_$_lo;
  }
});
$p.f = (function(obj) {
  if ((obj instanceof $c_Ljava_time_temporal_ValueRange)) {
    if ((this === obj)) {
      return true;
    } else {
      var x_$_lo = this.gq;
      var x_$_hi = this.gr;
      var $x_3 = obj;
      var x$1_$_lo = $x_3.gq;
      var x$1_$_hi = $x_3.gr;
      if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
        var x$2_$_lo = this.jf;
        var x$2_$_hi = this.jg;
        var $x_4 = obj;
        var x$3_$_lo = $x_4.jf;
        var x$3_$_hi = $x_4.jg;
        var $x_2 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        var x$4_$_lo = this.jd;
        var x$4_$_hi = this.je;
        var $x_5 = obj;
        var x$5_$_lo = $x_5.jd;
        var x$5_$_hi = $x_5.je;
        var $x_1 = (((x$4_$_lo ^ x$5_$_lo) | (x$4_$_hi ^ x$5_$_hi)) === 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var x$6_$_lo = this.fN;
        var x$6_$_hi = this.fO;
        var $x_6 = obj;
        var x$7_$_lo = $x_6.fN;
        var x$7_$_hi = $x_6.fO;
        return (((x$6_$_lo ^ x$7_$_lo) | (x$6_$_hi ^ x$7_$_hi)) === 0);
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  var x_$_lo = this.gq;
  var x_$_hi = this.gr;
  var x$1_$_lo = this.jf;
  var x$1_$_hi = this.jg;
  var lo = ((x_$_lo + x$1_$_lo) | 0);
  var hi = ((((x_$_hi + x$1_$_hi) | 0) + (((lo >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
  var x$2_$_lo = this.jf;
  var x$2_$_hi = this.jg;
  var lo$1 = ((16 + x$2_$_lo) | 0);
  var lo$2 = (((32 & lo$1) === 0) ? (lo << lo$1) : 0);
  var hi$2 = (((32 & lo$1) === 0) ? (((((lo >>> 1) | 0) >>> (~lo$1)) | 0) | (hi << lo$1)) : (lo << lo$1));
  var x$3_$_lo = this.jd;
  var x$3_$_hi = this.je;
  var lo$3 = ((48 + x$3_$_lo) | 0);
  var lo$4 = (((32 & lo$3) === 0) ? (((lo$2 >>> lo$3) | 0) | ((hi$2 << 1) << (~lo$3))) : (hi$2 >> lo$3));
  var hi$4 = (((32 & lo$3) === 0) ? (hi$2 >> lo$3) : (hi$2 >> 31));
  var x$4_$_lo = this.jd;
  var x$4_$_hi = this.je;
  var lo$5 = ((32 + x$4_$_lo) | 0);
  var lo$6 = (((32 & lo$5) === 0) ? (lo$4 << lo$5) : 0);
  var hi$6 = (((32 & lo$5) === 0) ? (((((lo$4 >>> 1) | 0) >>> (~lo$5)) | 0) | (hi$4 << lo$5)) : (lo$4 << lo$5));
  var x$5_$_lo = this.fN;
  var x$5_$_hi = this.fO;
  var lo$7 = ((32 + x$5_$_lo) | 0);
  var lo$8 = (((32 & lo$7) === 0) ? (((lo$6 >>> lo$7) | 0) | ((hi$6 << 1) << (~lo$7))) : (hi$6 >> lo$7));
  var hi$8 = (((32 & lo$7) === 0) ? (hi$6 >> lo$7) : (hi$6 >> 31));
  var x$6_$_lo = this.fN;
  var x$6_$_hi = this.fO;
  var lo$9 = ((48 + x$6_$_lo) | 0);
  var lo$10 = (((32 & lo$9) === 0) ? (lo$8 << lo$9) : 0);
  var hi$10 = (((32 & lo$9) === 0) ? (((((lo$8 >>> 1) | 0) >>> (~lo$9)) | 0) | (hi$8 << lo$9)) : (lo$8 << lo$9));
  return ((((lo$10 >>> 16) | 0) | (hi$10 << 16)) ^ (hi$10 >> 16));
});
$p.b = (function() {
  var x_$_lo = this.gq;
  var x_$_hi = this.gr;
  var x$1_$_lo = this.jf;
  var x$1_$_hi = this.jg;
  if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) !== 0)) {
    var ss = ("/" + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(this.jf, this.jg));
  } else {
    var ss = "";
  }
  var x$2_$_lo = this.jd;
  var x$2_$_hi = this.je;
  var x$3_$_lo = this.fN;
  var x$3_$_hi = this.fO;
  if ((((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) !== 0)) {
    var sl = ("/" + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(this.fN, this.fO));
  } else {
    var sl = "";
  }
  return (((($j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(this.gq, this.gr) + ss) + " - ") + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(this.jd, this.je)) + sl);
});
function $isArrayOf_Ljava_time_temporal_ValueRange(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dL)));
}
export { $isArrayOf_Ljava_time_temporal_ValueRange as $isArrayOf_Ljava_time_temporal_ValueRange };
var $d_Ljava_time_temporal_ValueRange = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_ValueRange, "java.time.temporal.ValueRange", ({
  dL: 1,
  a: 1
}));
export { $d_Ljava_time_temporal_ValueRange as $d_Ljava_time_temporal_ValueRange };
